import React from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-okaidia.css';

type HighlightedCodeProps = {
  codeTag: string,
  language?: string
}

function HighlightedCode ({ codeTag = '', language = 'js' }: HighlightedCodeProps) {
  const highlighted = React.useMemo(() => {
    if (typeof codeTag !== 'string') {
      throw new Error('Invalid children in Highlight, expected string');
    }
    const grammar = Prism.languages[language];
    if (!grammar) {
      throw new Error(`No grammar found for language '${language}'`);
    }
    return Prism.highlight(codeTag.trim(), grammar, language);
  }, [codeTag, language]);

  return (
    <pre className={`language-${language}`}>
      <code dangerouslySetInnerHTML={{ __html: highlighted }} />
    </pre>
  );
}

export default HighlightedCode;
